import I18n from 'I18n';
import { overrideLabelOnItemAndCheckBadge } from '../navUtils';
import { PageTypes, Paths } from '../../../components/RoutesPublic';
import { keyToNavData } from 'developer-docs-shared-components/config/navData/keys';
import memoize from 'react-utils/memoize';
import { navigation } from 'developer-docs-source/navigation';

/**
 * 'Guides' > 'CMS Development' nav config.
 *
 * Hard-coded data for the guides left hand navigation. Currently, labels and
 * breadcrumbs for guides are based off of the same key used for the API
 * Reference endpoints pages and align with a partial chunk of the guides urls.
 * While we are hardcoding these keys for now (see label property) below, we may
 * need to consider how we will determine Guides keys from the BE in the long run
 */

const cmsDevelopmentNavData = keyToNavData['/guides/cms'];
export const cmsDevelopmentNavConfig = memoize(() => {
  const commonPath = `${Paths.GUIDES}/cms`;
  const nav = navigation[commonPath];
  const navigationItems = nav.items.map(item => overrideLabelOnItemAndCheckBadge(item, cmsDevelopmentNavData, commonPath));
  const config = {
    commonPath,
    hasMdxOverview: true,
    locatorPageType: PageTypes.GUIDES,
    sectionLabel: I18n.text('developer-docs-ui.navigation.guides.cmsDevelopment'),
    items: navigationItems
  };
  return config;
});